module.exports = __webpack_public_path__ + "static/img/yy.7946f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy.jpg
// module id = 8RuC
// module chunks = 1